import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRetailBusinessItems, setRetailBusinessItems } from "../../../slices/dict";
export const useRetailBusinessItems = () => {
    const dispatch = useDispatch();
    const businessItems = useSelector(getRetailBusinessItems);
    const update = useCallback((value) => {
        dispatch(setRetailBusinessItems(value));
    }, [dispatch]);
    return [businessItems, update];
};
